import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import scrollToEnd from './scrollToEnd.js'

export default contract({
  scrollToEnd: array([
    scrollToEnd
  ]),
})